import { GetCart, GetTotal, ClearCart, GetCount } from './CartHandler';
import { confirm } from "react-confirm-box";
import { useState, useEffect, useRef } from 'react';
import axios from "axios";
import { useNavigate } from 'react-router-dom';
import "./addressModal.css";
const apiUrl = process.env.REACT_APP_BASEURL;


function PaymentBlock(props){
    
    const[purchaseClicked, setPurchaseClicked] = useState(false);
    const[orderType, setOrderType] = useState(2);
    const[orderNumber, setOrderNumber] = useState("");
    const [cart, setCart] = useState();
    const[requirePO, setRequirePO] = useState(false);
    const[clientOrder, setClientOrder] = useState(false);
    const [quoteClicked, setQuoteClicked] = useState(false);
    // const[ccNumber, setCCNumber] = useState("");
    // const[ccPayment, setCCPayment] = useState({
    //     "customerNumber": "string",
    //     "documentNumber": "awaiting order #",
    //     "userId": "string",
    //     "docType": 3,
    //     "ccNumber": "4111111111111111",
    //     "ccExpiration": "1225",
    //     "cvv2": "123"
    // });
    // useEffect(()=>{
    //   console.log("Received Payment Method", props.paymentMethod)
    //   switch(props.paymentMethod){
    //       case "QUOTE ONLY": setOrderType(1); console.log("You Are Sending Quote Only");break;
    //       case "2% 10/Net 30": setOrderType(2); console.log("You Are Sending an order");break;
    //   };
    //   console.log("OrderType is now",orderType)
    // },[props.paymentMethod]);

   useEffect(() => {
        // console.log(`YOO this the order type: ${orderType}`);
           axios
           .get(apiUrl + `/api/Orders/GetOrderNumber?orderType=${orderType}`,{
               headers: {
                   "Accept": "application/json",
                   "Content-Type": "application/json",
                   'Authorization': 'Bearer ' + props.token.token},
           })
           .then((response) => {
            //  console.log("PaymentBlock getOrderNumber Data:  ", response.data);
             setOrderNumber(response.data); //this could be quote number or invoice number depending on the orderType
       
           })
           .catch((error) => {
             console.log(error);
           });
       

   }, [orderType])


    // const getNewOrderNumber = () =>{
    //     console.log("Here is your token In Payment Block at GetNewOrderNumber: "+ props.token.token)
    //     axios
    //     .get(apiUrl + `/api/Orders/GetOrderNumber?orderType=3&oldOrderNumber=${orderNumber}`, {
    //         headers: headers
    //                 })
    //     .then((response) => {
    //       console.log("PaymentBlock getNewOrderNumber Data:  ", response.data);
    //       setOrderNumber(response.data);
    
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //     });
    // }

    const getRequirePO2 = () => {
        try {
            axios.get(apiUrl + `/api/Users/GetPoRequired?type=2`,{
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                    'Authorization': 'Bearer ' + props.token.token},
            })
              .then((response) => {
                // console.log("PaymentBlock getRequiredPO2 Data:", response.data);
                  setRequirePO(response.data);
    
              })
              .catch((error) => {
                console.log(error);
              });
          } catch (error) {
            console.log(error);
          }
        };
    
    
    // const getRequirePO3 = () => {
    //     try {
    //         axios.get(apiUrl + `/api/Users/GetPoRequired?type=3`, {
    //             headers: headers
    //         })
    //             .then((response) => {
    //             console.log("PaymentBlock getRequiredPO3 Data:", response.data);
        
    //                 setRequirePO(response.data);
    
    //             })
    //             .catch((error) => {
    //             console.log(error);
    //             });
    //         } catch (error) {
    //         console.log(error);
    //         }
    //     };
        
    let headers = {
        "Accept": "application/json",
        "Content-Type": "application/json",
        'Authorization': 'Bearer ' + props.token.token
    };

    const mounted = useRef()

    // const saveTransaction = () =>{
    //     try {
    //         axios.post(apiUrl + `/api/Payments/PersistTransaction`,JSON.stringify(transaction), {
    //             headers: headers
    //         })
    //             .then((response) => {
    //             console.log("PaymentBlock saveTransaction Data:", response.data);

    //             })
    //             .catch((error) => {
    //             console.log(error);
    //             });
    //         } catch (error) {
    //         console.log(error);
    //         }
    // }


    const options = {
        labels: {
            confirmable: "OK",
            cancellable: ""
        }
    }

    useEffect(() => {
        if(quoteClicked){
            setOrderType(1)
        }
    })
    function purchaseClick () {
     
        setTimeout(setPurchaseClicked(true),999);
        setTimeout(purchaseClickMethod(),500);
    };

    function quoteClick () {
        setQuoteClicked(true);
        setOrderType(1);
        setTimeout(setPurchaseClicked(true),999);
        setTimeout(quoteClickMethod(),1000);
        
    };

 

    function orderClick ( ) {
        setOrderType(2);
        setTimeout(setPurchaseClicked(true),999);
        setTimeout(purchaseClickMethod(),500);
        
        
    }


    function OrderSavedClear (){
        ClearCart();
        props.setCartCount(GetCount());
        props.onRequestClose();
        if(orderType===2){
            alert("Your order has been submitted with terms applied");
        }else{
            alert("Your quote has been submitted, you can download it from your portal.");
        }
    };

    // function CardTransactionClear(){
    //     if(transaction !== null){
    //         ClearCart();
    //         alert("Your Order Has Been Submitted");
    //         props.onRequestClose();
    //         console.log("INVOICE SUBMITTED!!!");
    //     }
    // }


    const purchaseClickMethod =()=>{

        if (requirePO === true && props.customerPO === null) {
            alert("A PO Number is required. Please Enter a PO Number.");
        } else {
            if(props.customerPO !== null){
                // if(props.paymentMethod === 'Credit Card'){
                //     submitOrderPO(); 
                //     verifyCard(); 
                //     saveTransaction();
                //     CardTransactionClear();
                // }else{
                    submitOrderPO();
                    OrderSavedClear();
                    setClientOrder(true);
                // }
            }else{
                // if(props.paymentMethod === 'Credit Card'){
                //     submitOrderNoPO(); 
                //     verifyCard(); 
                //     saveTransaction(); 
                //     CardTransactionClear();
                // }else{
                    submitOrderNoPO();
                    OrderSavedClear();
                    setClientOrder(true);
                }
                }
        }

    const quoteClickMethod =()=>{
        if (requirePO === true && props.customerPO === null) {
            alert("A PO Number is required. Please Enter a PO Number.");
        } else {
            if(props.customerPO !== null){
                // if(props.paymentMethod === 'Credit Card'){
                //     submitOrderPO(); 
                //     verifyCard(); 
                //     saveTransaction();
                //     CardTransactionClear();
                // }else{
                    submitOrderPO();
                    OrderSavedClear();
                // }
            }else{
                // if(props.paymentMethod === 'Credit Card'){
                //     submitOrderNoPO(); 
                //     verifyCard(); 
                //     saveTransaction(); 
                //     CardTransactionClear();
                // }else{
                    submitOrderNoPO();
                    OrderSavedClear();
                }
                }
    }



    const submitOrderPO = () =>{

        // console.log("You are here in PaymentBlock.submitOrderPo sending : ",cart);
        try {
            axios.post(apiUrl + `/api/Orders/AddInvoice?orderNumber=${orderNumber}&orderType=${orderType}&poNumber=${props.customerPO}&freight=${props.shipping}`,cart,{
                headers: headers
            })
                .then((response) => {
                // console.log("PaymentBlock submitOrderPO Data:", response.data);
                    
                })
                .catch(function(error){
                if (error.response){    
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.headers);
                }else if(error.request){
                // console.log("The request was made but no response was received");
                // console.log("`error.request` is an instance of XMLHttpRequest in the browser and an instance of");
                // console.log("http.ClientRequest in node.js");    
                console.log(error.request);
                } else {
                console.log("Something happened in setting up the request that triggered an Error");
                console.log('Error', error.message);    
                }
                });
            } catch (error) {
            console.log(error);
            }
    };

    const submitOrderNoPO = () =>{
        try {
            axios.post(apiUrl + `/api/Orders/AddInvoice?orderNumber=${orderNumber}&orderType=${orderType}&freight=${props.shipping}`,cart,{
                headers: headers
            })
                .then((response) => {
                // console.log("PaymentBlock submitOrderNoPO Data:", response.data);
                })
                .catch(function(error){
                    if (error.response){    
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                    }else if(error.request){
                    // console.log("The request was made but no response was received");
                    // console.log("`error.request` is an instance of XMLHttpRequest in the browser and an instance of");
                    // console.log("http.ClientRequest in node.js");    
                    console.log(error.request);
                    } else {
                    console.log("Something happened in setting up the request that triggered an Error");
                    console.log('Error', error.message);    
                    }
                    });
            } catch (error) {
            console.log(error);
            }
    };


    const[total, setTotal] = useState();
    const[transaction, setTransaction] = useState("");
    // const updateInputValue = (evt) =>{
    //     console.log("Credit Card Changed");
    //     setCCNumber(evt.target.val);
    // };


    // const verifyCard=() =>{
        
        //uncomment for credit card processing testing and go live.

        // console.log('you would be sending the following payment info: ', ccPayment);
        // console.log('Uncomment verifyCard() in PaymentBlock.js to go live with this feature....');
        // setCCNumber('');
        // setTransaction('Transaction Data From API Here');
        // try {
        //     axios.post(apiUrl + `/api/Payments/VerifyCard?amount=${total}`,JSON.stringify(ccPayment), {
        //         headers: headers
        //     })
        //         .then((response) => {
        //         console.log("PaymentBlock verifyCard Data:", response.data);
        //         let trns = response.data
        //         if (response.authCode === '') {
        //             setCCNumber('');
        //         } else {
        //             setTransaction(response.data);
        //         }
        //         })
        //         .catch((error) => {
        //         console.log(error);
        //         });
        //     } catch (error) {
        //     console.log(error);
        //     }
    // };

    const [year, setYear] = useState((new Date()).getFullYear());
    const [years, setYears] = useState(Array.from(new Array(10), (val, index) => index + year));


    useEffect(() => {
        setCart(GetCart());
        getRequirePO2();
        setTotal(props.orderTotal);
        // console.log("PaymentBlock.UseEffect Cart: ",cart);
      }, []);


      
      // Call the function when needed
      


      const paymentBlockConditionalRender = () =>{
      
//         if(props.paymentMethod==='CREDIT CARD'){
//         return(
//         <div id="checkout" className="fill">
//             <h1>Payment</h1>          
//             <div className="row">
//                 <input type="text" id="name" placeholder="Name on Card"  />
//                 <input type="text" id="cardNumber" placeholder="Card Number" value={ccNumber} onChange={evt => updateInputValue(evt)}/>
//                 <span>
//                     <label>{'Expiration: '}</label>
//                     <select id="month" placeholder="Select Exp. Month">
//                         <option value="01">01</option>
//                         <option value="02">02</option>
//                         <option value="03">03</option>
//                         <option value="04">04</option>
//                         <option value="05">05</option>
//                         <option value="06">06</option>
//                         <option value="07">07</option>
//                         <option value="08">08</option>
//                         <option value="09">09</option>
//                         <option value="10">10</option>
//                         <option value="11">11</option>
//                         <option value="12">12</option>
//                     </select>
//                     <select id="year" placeholder="Select Exp. Year">
//                         {
//                             years.map((year, index) => {
//                                 return <option key={`year${index}`} value={year}>{year}</option>
//                             })
//                         }
//                     </select>
//                 </span>
//             </div>
//             <br />
//             <div className="row">
//                 <input type="text" id="phoneNumber" placeholder="Phone Number" />
//                 <input type="text" id="cvv" placeholder="CVV" />
//                 <button id="purchaseButton" onClick={purchaseClick}>Purchase</button>
//             </div>                
//         </div>
//     );
if(props.paymentMethod === "QUOTE ONLY"){
    return(
    <div id="checkout" className="fill center">
            <h1 className = "flex-row center">You have Selected Quote Only</h1>
            <div className = "flex-row center">Once you have clicked "Get Quote" your quote will show up in your customer portal.</div>          
            <div className="flex-row center">
                {props.paymentMethod}
            </div>
            <br />
            <div className="flex-row center">
                <input type="text" id="phoneNumber" placeholder="Phone Number" />
                </div> 
            <div className="flex-row center lg:mt-3">
                <button className = "cat-button" id="purchaseButton" onClick={quoteClick}>Get Quote</button>
            </div>                
    </div>)

}else{
    return(

    <div id="" className="fill center">
            <h1 className = "flex-row center">Payment Terms </h1>
            <div className = "flex-row center">Here are the payment terms on Record for you</div>          
            <div className="flex-row center">
                {props.paymentMethod}
            </div>
            <br />
            <div className="flex-row center">
                <input type="text" id="phoneNumber" placeholder="Phone Number" />
                </div>
            <div className='flex-row gap-1 lg:mt-3 mt-[5rem]'>
            <div className=" ">
                <button className = "cat-button lg:w-[21rem]" id="" onClick={quoteClick} >Quote Only</button>
            </div>                
            <div className=" ">
                <button className = "cat-button lg:w-[21rem]" id="" onClick={orderClick}>Place Order</button>
            </div>  
                    
            </div> 
    </div>
    )
      }};

return (
    <>
    
    <div className = "p-blo col-2 " >{paymentBlockConditionalRender()}</div>
   
    </>
);
}


export default PaymentBlock;